
export default {
  head() {
    return {
      title: "Agence Google Ads | SEA à Pantin dès 290€/mois - ALEO AGENCY",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "ALEO, agence Google Ads à Pantin certifiée Google Partner, accompagne les entreprises pantinoises pour accroître leur visibilité en ligne et attirer de nouveaux clients.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content: "Agence Google Ads à Pantin dès 290€/mois - ALEO AGENCY",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "ALEO, agence Google Ads à Pantin certifiée Google Partner, accompagne les entreprises pantinoises pour accroître leur visibilité en ligne et attirer de nouveaux clients.",
        },
      ],
    };
  },
};
